import { render } from "./SidebarImage.vue?vue&type=template&id=b545fbb6&scoped=true"
import script from "./SidebarImage.vue?vue&type=script&lang=js"
export * from "./SidebarImage.vue?vue&type=script&lang=js"

import "./SidebarImage.vue?vue&type=style&index=0&id=b545fbb6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b545fbb6"]])

export default __exports__